import React, { FC } from 'react';

import { cn } from '@/lib/utils';

interface PageLayoutProps {
  className?: string;
  children: React.ReactNode;
}

const PageLayout: FC<PageLayoutProps> = ({
  className,
  children,
}: PageLayoutProps) => (
  <div className={cn('flex flex-col overflow-hidden gap-2', className)}>
    {children}
  </div>
);

export default PageLayout;
